<template>
  <lazy-pdp-section-body-elevated
    v-if="$feature.tempHeaderVariation === 'elevated' || $feature.tempHeaderVariation === 'basic'"
  />
  <lazy-pdp-section-body v-else />
</template>

<script lang="ts" setup>
const LazyPdpSectionBody = defineAsyncComponent(() => import('#brand/regions/nora/components/pdp/section/Body.vue'))
</script>
